import { useTranslation } from 'react-i18next';
import './DataNotesTab.css';

interface DataNotesRow {
  indicator: string;
  source: string;
  reliability: string;
}

export const DataNotesTab: React.FC = () => {
  const { t } = useTranslation();
  const rows = t('analytics.dataNotes.rows', { returnObjects: true }) as DataNotesRow[];

  return (
    <div className="analytics-data-notes">
      <div className="analytics-panel">
        <h3>{t('analytics.dataNotes.title')}</h3>
        <p className="analytics-panel-sub">{t('analytics.dataNotes.subtitle')}</p>
        <div className="analytics-tech-table-container">
          <table className="analytics-tech-table">
            <thead>
              <tr>
                <th>{t('analytics.dataNotes.columns.indicator')}</th>
                <th>{t('analytics.dataNotes.columns.source')}</th>
                <th>{t('analytics.dataNotes.columns.reliability')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.indicator}>
                  <td>{row.indicator}</td>
                  <td>{row.source}</td>
                  <td>{row.reliability}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="analytics-data-notes-footnote">{t('analytics.dataNotes.footnote')}</p>
      </div>
    </div>
  );
};

export default DataNotesTab;
